import React from 'react'

import './styles.scss'

import { type ReportingBasis } from './types'

interface ReportingBasisToggleProps {
  value: ReportingBasis
  onChange: (next: ReportingBasis) => void | Promise<void>
  disabled?: boolean
}

const OPTIONS: { value: ReportingBasis, label: string }[] = [
  { value: 'CASH', label: 'Cash' },
  { value: 'ACCRUAL', label: 'Accrual' },
]

const ToggleOption = ({
  label,
  value,
  isSelected,
  isDisabled,
  onSelect,
}: {
  label: string
  value: ReportingBasis
  isSelected: boolean
  isDisabled: boolean
  onSelect: (next: ReportingBasis) => void
}) => (
  <button
    type='button'
    role='radio'
    aria-checked={isSelected}
    disabled={isDisabled}
    className='Layer__UI__ToggleOption'
    data-selected={isSelected || undefined}
    data-disabled={isDisabled || undefined}
    onClick={() => {
      if (!isSelected && !isDisabled) onSelect(value)
    }}
  >
    {isSelected && (
      <span className='Layer__UI__ToggleOption-SelectionIndicator' />
    )}
    <span className='Layer__UI__Toggle-Option-Content'>
      <span>{label}</span>
    </span>
  </button>
)

export const ReportingBasisToggle = ({
  value,
  onChange,
  disabled,
}: ReportingBasisToggleProps) => (
  <div
    className='Layer__UI__Toggle'
    role='radiogroup'
    aria-label='Reporting basis'
    data-basis-toggle
    data-size='small'
  >
    {OPTIONS.map(option => (
      <ToggleOption
        key={option.value}
        label={option.label}
        value={option.value}
        isSelected={option.value === value}
        isDisabled={Boolean(disabled)}
        onSelect={onChange}
      />
    ))}
  </div>
)
